﻿export const unflattenConfiguration = (flatData: Record<string, any>) => {
  const result: any = {};

  Object.keys(flatData).forEach((key) => {
    const parts = key.split('.');
    let current = result;

    for (let i = 0; i < parts.length; i++) {
      const part = parts[i];

      // If we are at the last part of the key, set the value
      if (i === parts.length - 1) {
        current[part] = flatData[key];
      } else {
        // Otherwise, keep nesting
        current[part] = current[part] || {};
        current = current[part];
      }
    }
  });

  return result;
};
